import { COLOR_SCHEMES } from './tmuaColorSchemes';

/** Visual tokens sampled from TMUA Pearson VUE harvest (~1600×1000). */
export const TMUA_PEARSON_TOKENS = {
  titleBarBg: '#006DAA',
  toolbarBg: '#4678BE',
  footerBg: '#006DAA',
  titleBarFg: '#FFFFFF',
  itemAreaBg: '#FFFFFF',
  itemAreaFg: '#000000',
  nextDefaultBg: '#FFFF00',
  nextDefaultFg: '#FFFFFF',
  instructionBody: '#000000',
  instructionTableBorder: '#000000',
  navHeaderBg: '#4678BE',
  navRowAlt: '#F2F2F2',
  navRowCurrent: '#FFF44A',
  nextOutlineBg: 'transparent',
  nextOutlineFg: '#FFFFFF',
  flagOn: '#FFFF00',
  flagIdle: '#FFFFFF',
  navCurrentRow: '#FFFF00',
  statusUnseen: '#C62828',
  statusComplete: '#1B3A4B',
  statusIncomplete: '#6B5B16',
  pillCorrect: '#2E7D32',
  pillCorrectBg: '#C8E6C9',
  pillIncorrect: '#C62828',
  pillIncorrectBg: '#F8BBD0',
  pillUnseen: '#EF6C00',
  pillUnseenBg: '#FFE0B2',
  reviewTeal: '#00838F',
  reviewPageBg: '#E8EAED',
  dialogBg: '#006DAA',
  dialogFg: '#FFFFFF',
  fontUi: 'Tahoma, Arial, Helvetica, sans-serif',
  titleBarHeight: 52,
  toolbarHeight: 32,
  footerHeight: 36,
  footerHeightMobile: 48,
  // DM drag-and-drop Yes/No widget (TmuaPearsonDragYesNo) — pearsonDefault fallback
  // fills, used when getTmuaPearsonChrome's isDefault branch applies.
  ynDropzoneEmptyBg: '#B2A8A8',   // sampled rgb(178,168,168), 10-dm-drag-empty.png
  ynDropzoneEmptyBorder: '#8F8686',
  ynTrayBg: '#DADADA',            // sampled rgb(218,218,218)
  ynTileBg: '#FFFFFF',
  ynTileBorder: '#000000',
  ynTileText: '#000000',
  ynRowGap: 18,
  ynStatementGap: 8,
  ynTrayGap: 18,
  ynDropzoneWidth: 119,
  ynDropzoneHeight: 66,
  ynDropzoneMinWidth: 70,
  ynStatementRestWidth: 633,
  ynStatementFontRest: 16,
  ynStatementFontFloor: 12,
  ynStatementLineHeightRest: 1.45,
  ynStatementLineHeightFloor: 1.2,
  ynTileFontRest: 16,
  ynTileFontFloor: 11,
  ynTrayPadX: 13,
  ynTrayWidth: 145,
  ynDropzoneWidthMobile: 88,
  ynDropzoneHeightMobile: 48,
  ynDragThresholdPx: 6,
  ynAutoScrollEdgePx: 48,
  ynGhostZIndex: 10300,
  // Photograph 16-dm-drag-ghost-detail.png — outline sampled as blue-violet,
  // not title-bar navy and not the black tray-card border.
  ynGhostOutline: '#5E65B8',
  ynGhostText: '#7D7D7D',
  ynGhostFill: '#FFFFFF',
  ynGhostTransformFine: 'translate(-68%, -70%)',
  ynGhostTransformCoarse: 'translate(-68%, calc(-100% - 28px))',
  // SJT most/least drag (TmuaPearsonDragMostLeast) — bar/tray fills sampled
  // from pearson-most-least-drag.png; rest geometry from pearson-target-boxes.png
  // (1024px capture: label ~90×38 / bar ~385×39). Heights are raised so two
  // centred label lines and padded action cards contain wrapped text.
  mlDropzoneEmptyBg: '#BAB2B0',   // sampled rgb(186,178,176)
  mlTrayBg: '#DFDFDF',            // sampled rgb(223,223,223)
  mlLabelRestWidth: 90,
  mlLabelRestHeight: 52,
  mlLabelMinWidth: 56,
  mlLabelMinHeight: 36,
  mlLabelBarGap: 13,
  mlBarRestWidth: 385,
  mlBarRestHeight: 52,
  mlBarMinWidth: 351,             // 385 − (90 − 56): chrome floors together at deficit/2
  mlBarMinHeight: 36,
  mlRowGap: 16,
  mlTrayPad: 14,
  mlTrayIndent: 22,
  mlCardRestHeight: 72,
  mlCardMinHeight: 48,
  mlCardPadX: 16,
  mlCardPadY: 12,
  mlLabelFontRest: 13,
  mlLabelFontFloor: 11,
  mlCardFontRest: 16,
  mlCardFontFloor: 12,
  mlCardLineHeightRest: 1.45,
  mlCardLineHeightFloor: 1.2,
};

export function getTmuaPearsonChrome(colorScheme) {
  const scheme = COLOR_SCHEMES[colorScheme] || COLOR_SCHEMES.pearsonDefault;
  const isDefault = !colorScheme || colorScheme === 'pearsonDefault';
  if (isDefault) {
    return {
      titleBar: TMUA_PEARSON_TOKENS.titleBarBg,
      toolbar: TMUA_PEARSON_TOKENS.toolbarBg,
      footer: TMUA_PEARSON_TOKENS.footerBg,
      chromeFg: TMUA_PEARSON_TOKENS.titleBarFg,
      body: TMUA_PEARSON_TOKENS.itemAreaBg,
      text: TMUA_PEARSON_TOKENS.itemAreaFg,
      border: scheme.border,
      ynDropzoneEmptyBg: TMUA_PEARSON_TOKENS.ynDropzoneEmptyBg,
      ynTrayBg: TMUA_PEARSON_TOKENS.ynTrayBg,
    };
  }
  return {
    titleBar: scheme.chrome,
    toolbar: scheme.chrome,
    footer: scheme.chrome,
    chromeFg: scheme.text,
    body: scheme.body,
    text: scheme.text,
    border: scheme.border,
    ynDropzoneEmptyBg: scheme.ynDropzoneEmptyBg,
    ynTrayBg: scheme.ynTrayBg,
  };
}
